
export default {
  name: 'Channels',
};
